class Cmd {
    constructor(fn) {
        if (!fn) {
            throw new Error("Computation needs to be provided");
        }
        this.fn = fn;
    }
    static of(fn) {
        return new Cmd(fn);
    }
    static batch(...cmds) {
        cmds.forEach((c) => {
            if (!(c instanceof Cmd)) {
                throw new Error("You can only provide Cmd's to batch");
            }
        });
        return new Cmd((dispatch, getState) => {
            cmds.forEach((c) => c.unsafePerform(dispatch, getState));
        });
    }
    tag(tag) {
        const c = this.fn;
        return new Cmd((dispatch, getState) => {
            const newDispatch = (action) => dispatch({ type: tag, payload: action });
            newDispatch.toString = () => `dispatch_${tag}()`;
            return c(newDispatch, getState);
        });
    }
    unsafePerform(dispatch, getState) {
        return this.fn(dispatch, getState);
    }
}
Cmd.none = Cmd.of(() => { });
export default Cmd;
